import { Injectable } from '@angular/core';
import * as _ from "lodash";
import { HelpersService } from '../helpers/helpers.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class WorkflowDatasourceService {

  constructor(
    private _helpers:HelpersService,
    private _http:HttpClient
  ) { }

  /**
         * getData: Method handles data fetching from the various sources
         * @param  {object}   params : Contains parameter such as type, expression and so on
         *                             Possible type:
         *                                 > 1: If data wants to fetched from Data set. This is not yet handled
         *                                 > 2: Data to fetch from API
         *                                 > 3: Data to fetch by resolving the expression
         */
  getData(params, cb) {
    if (params && !_.isEmpty(params)) {
      switch (params["type"]) {
        case 1:
          // For the dataset
          break;
        case 2:
          // Get data through API.
          this.getDataFromAPI(params, (error:any, data:any) =>{
            if (error) {
              cb(true);
            } else {
              cb(false, data);
            }
          });
          break;
        case 3:
          // Get data by resolving expression.
          this.resolveExpression(params,  (error:any, data:any)=> {
            if (error) {
              cb(true);
            } else {
              cb(false, data);
            }
          })
          break;
        default:
          console.log("Invalid Type: Type not supported.");
      }
    }
  }

  /**
   * getDataFromAPI: This method will fetch the data from the API.
   * @param  {object}   params : Parameters such as 
   *                                 > method(POST, PUT, DELETE, GET)
   *                                 > url: URL of the API
   *                                 > data: This will the parameters for the API.
   */
  getDataFromAPI(params:any, cb:any) {
    if (!_.isEmpty(params)) {

      var paramForAPI = {};
      for (var key in params["data"]) {
        if (params["data"][key].indexOf("{{") >= 0) {
          this.resolveExpression({ "expression": params["data"][key] }, function (error, response) {
            if (error) { } else {
              paramForAPI[key] = response["data"];
            }
          });
        } else {
          paramForAPI[key] = params["data"][key];
        }
      }

      var req:any = {
        "method": params["method"],
        "url": params["url"],
        "params": paramForAPI
      }
 
      this._http.request(req).subscribe((response:any) => {
        if (_.get(response, "data.code") == 0) {
          cb(false, response.data.data);
        } else {
          cb(false, []);
        }
      }, (error:any) => {
        cb(true, false);
      });
    }
  }

  /**
   * resolveExpression: This method will get the data by resolving the expression
   * @param  {object}   params : Parameters such as:
   *                             > expression: Expression which needs to be resolved.
   */
  resolveExpression(params, cb) {
    if (!_.isEmpty(params) && params["expression"]) {
      var expression = params["expression"];
      if (this.validateExpression(expression)) {
        // Seperate out brances from the expression
        var expWithoutBrace = expression.split(/[{\}]{1,2}/)[1];
        // Seperate expression from dot.
        var expSeperatedByDot = expWithoutBrace.split(".");

        // Get the first element: This will let us know from where data needs to be fetched
        // Eg. {{brand.status_list['name']}}: Here brand needs to be traversed
        var keyToFetchFrom =_.get(expSeperatedByDot, "0");
        var fieldToFetchFrom = null;

        if (keyToFetchFrom.indexOf("brand") >= 0) {
          fieldToFetchFrom = Helpers.brandDetails;
        }

        var expToTraverse = "";
        var fieldToFiterWith = null;
        _.each(expSeperatedByDot, (exp, index)=> {
          if (index != 0) {
            // If the expression contains [] then seprate out the string before "[".
            // Eg. detailed_feedback_items['field_id'] will return detailed_feedback_items
            var fieldToFetch = exp;
            if (exp.indexOf("[") >= 0) {
              // If exp contains "["
              fieldToFetch = exp.substr(0, exp.indexOf('['));
              fieldToFiterWith = exp.substr(fieldToFetch.length);
            }
            expToTraverse += ((expToTraverse && expToTraverse.length) ? "." : "") + fieldToFetch;
          }
        })

        if (fieldToFiterWith) {
          this.filterOutByFilter(fieldToFetchFrom, expToTraverse, fieldToFiterWith,  (error, response)=> {
            if (error) {
              console.log("Error while resolving expression for the filter.");
            } else {
              if (_.get(params, "rules")) {
                this.filterBasedOnRules(response.data, params.rules,  (filteredData)=> {
                  cb(null, { "data": filteredData });
                });
              } else {
                cb(null, response);
              }
            }
          })
        } else {
          cb(null, { "data":_.get(fieldToFetchFrom, expToTraverse) });
        }
      } else {
        cb("Invalid Expression", null);
      }
    } else {
      console.log("Incorrect params for resolving expression.");
    }
  }

  filterBasedOnRules(data, rules, cb) {
    if (rules && rules.isAccessRule) {
      var accessDetail:any = this._helpers.getLoggedInAccessLevelAndValue();
      rules.rhs = (_.isEmpty(accessDetail)) ? null : accessDetail.level;
    }
    // If rules is an empty object
    if (rules && rules.rhs && rules.lhs && rules.operator) {
      var operatorMapper = {
        "==": function (a, b) { return a == b },
        "!=": function (a, b) { return a != b },
        ">": function (a, b) { return a > b },
        ">=": function (a, b) { return a >= b },
        "<": function (a, b) { return a < b },
        "<=": function (a, b) { return a <= b },
        "$has": function (a, b) {
          var joinOp = 'null';
          if (b.indexOf('||')) {
            joinOp = '||';
          } else if (b.indexOf('&&')) {
            joinOp = '&&';
          }
          var results:any = [];
          if (joinOp) {
            var values = b.split(joinOp);
            if (values && values.length) {
              values.forEach(function (val) {
                if (a.indexOf(val) > -1) {
                  results.push(true);
                }
              })
            }
            if (joinOp == '||' && results.length == 1) {
              return true;
            } else if (joinOp == '&&' && results.length == values.length) {
              return true;
            } else {
              return false;
            }
          } else {
            return ((a.indexOf(b) > -1) ? true : false)
          }
          return ((a.indexOf(b) > -1) ? true : false)
        }
      }
      var filteredData:any = [];
      var lhs = null;
      _.each(data, function (d) {
        lhs =_.get(d, rules['lhs'])
        if (operatorMapper[rules['operator']](lhs, rules['rhs'])) {
          filteredData.push(d);
        }
      });
      cb(filteredData);
    } else {
      cb([]);
    }
  }

  /**
   * validateExpression: Method which validate the expression for the following:
   *                     > expression should not be empty
   *                     > expression must contain '{{'
   * @param  {string} expression : Expression to be resolved
   * @return {boolean}           : Whether the expression is valid or not.
   */
  validateExpression(expression) {
    var isValid = (!_.isEmpty(expression) && (expression.indexOf("{{") >= 0)) ? true : false;
    return isValid;
  }

  /**
   * filterOutByFilter: This method accepts the data(fetched while resolving the expression) and apply the filters on data if available.
   * @param  {string}   fieldToFetchFrom 
   * @param  {string}   expToTraverse    
   * @param  {string}   fieldToFiterWith 
   * @example
   *         If expression is '{{brand.detailed_feedback_items['display_name'][is_primary_comment==true]}}'
   *         > 'fieldToFetchFrom' will be brand
   *         > 'expToTraverse' will be detailed_feedback_items
   *         > fieldToFiterWith will be ['display_name'][is_primary_comment==true]
   */
  filterOutByFilter(fieldToFetchFrom, expToTraverse, fieldToFiterWith, cb) {
    var operatorMapper = {
      "==": function (a, b) { return a == b },
      "!=": function (a, b) { return a != b },
      ">": function (a, b) { return a > b },
      ">=": function (a, b) { return a >= b },
      "<": function (a, b) { return a < b },
      "<=": function (a, b) { return a <= b },
      "$has": function (a, b) {
        var joinOp = 'null';
        if (b.indexOf('||')) {
          joinOp = '||';
        } else if (b.indexOf('&&')) {
          joinOp = '&&';
        }
        var results:any = [];
        if (joinOp) {
          var values = b.split(joinOp);
          if (values && values.length) {
            values.forEach(function (val) {
              if (a.indexOf(val) > -1) {
                results.push(true);
              }
            })
          }
          if (joinOp == '||' && results.length == 1) {
            return true;
          } else if (joinOp == '&&' && results.length == values.length) {
            return true;
          } else {
            return false;
          }
        } else {
          return ((a.indexOf(b) > -1) ? true : false)
        }
        return ((a.indexOf(b) > -1) ? true : false)
      }
    }
    // Now, expToTraverse will contains the nested field available in fieldToFetchFrom(brands, status_lis)
    // Basically, the below satement will now return an array such as field_definitions, status_list, category_list and so on.
    var expressionResponse =_.get(fieldToFetchFrom, expToTraverse)

    // Now, seprate out the fields and conditions 
    // Eg. ['display_name'][is_primary_comment==true] will be  ["", "'display_name'", "is_primary_comment==true", ""]
    var splitExpressionByBrackets = fieldToFiterWith.split(/[[\]]{1,2}/);

    // Just after the expToTraverse, there is a field which mentioned the display field(which needs to be visible in the drop down)
    // Eg. detailed_feedback_items['display_name'][is_primary_comment==true]: "display_name" will be the field which needs to be displayed
    var displayField = splitExpressionByBrackets[1];

    // Remove single quotes if avialble
    displayField = displayField.replace(/'/g, "");
    this.prepareFilterConditions(splitExpressionByBrackets,  (conditions) =>{
      // Now, traverse through each expressionResponse and filter out based on conditions
      expressionResponse = _.filter(expressionResponse,  (data)=> {
        var addToResponse = true;
        var lhsValue = null;
        // loop through each conditions
        for (let index in conditions) {
          let lhsValue =_.get(data, conditions[index]["lhs"]) || '';
          lhsValue = (lhsValue == true || lhsValue == false) ? String(lhsValue) : lhsValue;
          // If the any of the condition doesn't match then eliminate that data
          if (!operatorMapper[conditions[index]["operator"]](lhsValue, conditions[index]["rhs"])) {
            addToResponse = false;
            break;
          }
        }
        // Return only those data which matched from all the conditions
        if (addToResponse) {
          return data;
        } else {
          return false;
        }
      })
      cb(null, { "displayField": displayField, "data": expressionResponse });
    });
  }

  /**
   * prepareFilterConditions: The method extracts the filters to be applied.
   * @param  {string}   filters :
   *                    Eg. If filters is "['display_name'][is_primary_comment==true]"
   *                        > In filter, the first square brackets refers to the field which needs to be displayed.
   *                        > And the next will be the filters on the data.
   *                        > There can be multiple filters.
   */
  prepareFilterConditions(filters, cb) {
    var conditions:any = [];
    _.each(filters,  (filter, index) =>{
      // Ignore the filter with "" as string. 
      // Also, ignore the 1st index as, it will contains the field to fetch 
      // Eg. In ['display_name'][is_primary_comment==true], 'display_name' refers to the field which needs to be displayed
      if (filter && filter.length && index != 1) {
        conditions.push(this.fetchOperatorAndOperands(filter));
      }
    });
    cb(conditions);
  }

  /**
   * fetchOperatorAndOperands: Extract lhs, rhs, operator from the filter
   * @param  {string} filter : Filter such as 'is_primary_comment==true', 'field_id==5b3f0592600cca6c6bc30a4b'
   */
  fetchOperatorAndOperands(filter) {
    var operator:any = null;
    if (filter.indexOf("==") >= 0) {
      operator = "==";
    } else if (filter.indexOf("!=") >= 0 || filter.indexOf("<>") >= 0) {
      operator = "!=";
    } else if (filter.indexOf(">") >= 0) {
      operator = ">";
    } else if (filter.indexOf(">=") >= 0) {
      operator = ">=";
    } else if (filter.indexOf("<") >= 0) {
      operator = "<";
    } else if (filter.indexOf("<=") >= 0) {
      operator = "<=";
    } else if (filter.indexOf("$has") >= 0) {
      operator = "$has";
    }
    var operands = filter.split(operator);
    return ({ "lhs": operands[0], "rhs": operands[1], "operator": operator });
  }
}
